module.exports = __webpack_public_path__ + "img/4.6403f965.png";